module.exports = __webpack_public_path__ + "media/images/niq-undo-f267f20a96a12ecf0d7e328c9f84e611.svg";